import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";
import { toInitials } from "../../formatters/toInitials/toInitials";
import { classNames } from "../../utils/classNames";

const avatarVariants = cva(
	"relative inline-flex h-8 w-8 items-center justify-center overflow-hidden rounded-full bg-avatar-primary font-medium md:h-10 md:min-h-[40px] md:w-10 md:min-w-[40px]",
	{
		variants: {
			variant: {
				subtle: "bg-avatar-primary text-primary-strong",
				filled: "bg-primary text-white",
			},
		},
		defaultVariants: {
			variant: "subtle",
		},
	},
);

export type AvatarProps = {
	firstName?: string | null;
	lastName?: string | null;
	variant?: VariantProps<typeof avatarVariants>["variant"];
};

export const Avatar = ({ firstName, lastName, variant }: AvatarProps) => {
	const initials = toInitials({ firstName, lastName });

	return (
		<div className={classNames(avatarVariants({ variant }))}>
			<span aria-hidden>{initials}</span>
		</div>
	);
};
